import { ROUTE_MAIN_PAGE_CONFIGS_EDIT } from '@@partner:config/routes'
import { formatDate } from '@@partner:helpers/util'
import { RemoteMainPageConfig } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import React from 'react'
import { generatePath, Link } from 'react-router-dom'
import { Button, FlexboxGrid, List, Tag } from 'rsuite'
import { MAIN_PAGE_CONFIG_TYPE_LABELS } from './constants'

type ConfigListItemProps = {
  config: RemoteMainPageConfig
  brandSlug: string
  isCurrent?: boolean
}

export default function ConfigListItem ({
  config,
  brandSlug,
  isCurrent
}: ConfigListItemProps) {

  const styles = {
    current: {
      background: ' #e6ffe6 ',
      borderLeft: '4px solid #42cf13'
    },
    default: {
      background: '#e6f7ff',
      borderLeft: '4px solid #3498ff'
    },
    others: {
      background: 'inherit',
      borderLeft: 'none'
    }
  }

  const style = config.isDefault
    ? styles.default
    : isCurrent
      ? styles.current
      : styles.others
  
  return (
    <List.Item
      key={config.id}
      style={{
        padding: '12px 16px',
        background: style.background,
        borderLeft: style.borderLeft,
      }}
    >
      <FlexboxGrid justify="space-between" align="middle">
        <FlexboxGrid.Item colspan={18}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ fontWeight: 'bold', fontSize: 14 }}>ID: {config.id}</div>
            <Tag color="violet" size="sm">
              {MAIN_PAGE_CONFIG_TYPE_LABELS[config.type] ?? config.type}
            </Tag>
            {config.isDefault && (
              <Tag color="blue" size="sm">По умолчанию</Tag>
            )}
          </div>
          <div style={{ fontWeight: 'bold', fontSize: 14 }}>{config.name}</div>

          <div style={{ marginTop: 4 }}>
            <span style={{ marginRight: 10 }}>Активирован:</span>
            <Tag color={config.is_active ? 'green' : 'red'}>
              {config.is_active ? 'Да' : 'Нет'}
            </Tag>
          </div>
          

          <div style={{ marginTop: 4 }}>
            {config.activeFrom || config.activeUntil ? (
              <>
                Активно
                {config.activeFrom && (
                  <> с <b>{formatDate(new Date(config.activeFrom))}</b></>
                )}
                {config.activeUntil && (
                  <> по <b>{formatDate(new Date(config.activeUntil))}</b></>
                )}
              </>
            ) : (
              <div></div>
            )}
          </div>
        </FlexboxGrid.Item>

        <FlexboxGrid.Item colspan={6} style={{ textAlign: 'right' }}>
          <Button
            size="sm"
            appearance="ghost"
            color="blue"
            as={Link}
            to={generatePath(ROUTE_MAIN_PAGE_CONFIGS_EDIT, {
              brandSlug,
              mainPageConfigId: config.id
            })}
          >
            Изменить
          </Button>
          
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </List.Item>
  )
}